import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  Save,
  MailOutline,
  WhatsApp,
  PercentOutlined,
  ContentCopy,
  Refresh,
} from "@mui/icons-material";
import {
  DialogContent,
  Grid,
  Snackbar,
  TextField,
  Slide,
  FormControl,
  Alert,
  Dialog,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import Moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";

import LoadStates from "components/services/LoadStates";
import LoadCities from "components/services/LoadCities";
import imgLoader from "assets/img/loading.gif";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function EditCompanyAdmin(props) {
  const classes = useStyles();

  const [loaders, setLoaders] = useState(false);
  const [disabledCities, setDisabledCities] = useState(false);
  const [error, setError] = useState("");
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = useState(false);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });
  const [copied, setCopied] = useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    document_id: props.id.row.nRuc,
    name: props.id.row.name,
    email: props.id.row.email,
    phone: props.id.row.phone,
    states: props.id.row.provinceId,
    statesData:
      props.id.row.provinceId !== null
        ? { id: props.id.row.provinceId, name: props.id.row.province.name }
        : null,
    cities: props.id.row.cityId,
    citiesData:
      props.id.row.cityId !== null
        ? { id: props.id.row.cityId, name: props.id.row.cities.name }
        : null,
    direccion: props.id.row.direccion,
    percentage: props.id.row.percentage ? props.id.row.percentage : "",
    token: props.id.row.token ? props.id.row.token : null,
    errorName: false,
    errorDocument: false,
    errorEmail: false,
    errorPhone: false,
    errorStates: false,
    errorCities: false,
    errorDireccion: false,
    errorPercentage: false,
  });

  const handleChange = (prop) => (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: event.target.value,
      errorName: false,
      errorDocument: false,
      errorEmail: false,
      errorPhone: false,
      errorDireccion: false,
      errorPercentage: false,
    }));

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);

    if (values.document_id.length === 0) {
      setValues({ ...values, errorDocument: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Nro. Ruc" es obligatorio.',
      });
    } else if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Nombre" es obligatorio.',
      });
    } else if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Correo Electrónico" es obligatorio.',
      });
    } else if (values.states === "") {
      setValues({ ...values, errorStates: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Provincias" es obligatorio.',
      });
    } else if (values.cities === "") {
      setValues({ ...values, errorCities: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Ciudad" es obligatorio.',
      });
    } else if (values.direccion.length === 0) {
      setValues({ ...values, errorDireccion: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Dirección" es obligatorio.',
      });
    } else if (values.phone.length === 0) {
      setValues({ ...values, errorPhone: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Número de whatsapp" es obligatorio.',
      });
    } else if (values.percentage === "") {
      setValues({ ...values, errorPercentage: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un porcentaje de ganacia.",
      });
    } else {
      const dataValue = {
        name: values.name,
        nRuc: values.document_id,
        provinceId: values.states,
        cityId: values.cities,
        direccion: values.direccion,
        email: values.email,
        phone: values.phone,
        percentage: values.percentage,
        token: values.token,
      };

      axios
        .put(`${urlServices}company/${props.id.row.id}`, dataValue, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
        .then((response) => {
          setAlert({
            ...alert,
            openAlert: true,
            errorAlert: "success",
            mensaje: "Empresa editada con éxito.",
          });
          setLoaders(false);

          props.callBackRefresh();
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setMensageSystem(
              "La sesión ha expirado, vuelva a iniciar sesión ..."
            );
            setError(true);

            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 4000);
          } else if (e.response.status === 500) {
            setMensageSystem("Error en la consulta con sel servidor.");
            setError(true);
          }
        });
    }
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  const changeStates = (data) => {
    setValues({
      ...values,
      states: data !== null ? data.id : "",
      statesData: data !== null ? data : "",
      errorStates: false,
      cities: "",
      citiesData: "",
    });

    setDisabledCities(data !== null ? false : true);
    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const changeCities = (data) => {
    setValues({
      ...values,
      cities: data !== null ? data.id : "",
      citiesData: data !== null ? data : "",
      errorCities: false,
    });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  // Función para formatear el token (mostrar primeros 4 y últimos 4 caracteres)

  const formatToken = (token) => {
    if (!token) return "";
    if (token.length <= 30) return token;

    const firstFour = token.substring(0, 7);
    const lastFour = token.substring(token.length - 7);
    return `${firstFour}......................${lastFour}`;
  };

  // Función para generar un token aleatorio
  const generateToken = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const length = 32; // Longitud típica para tokens API

    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    setValues((prevValues) => ({
      ...prevValues,
      token: result,
    }));
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        // onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error && <Alert severity="error">{mensageSystem}</Alert>}
                <div className={classes.titleCardFilter}>Editar empresa</div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid
                  container
                  spacing={1}
                  style={{
                    backgroundColor: "rgb(248, 248, 248, 0.71)",
                    borderRadius: 5,
                    padding: 10,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ textAlign: "right", color: "#000" }}
                  >
                    <b style={{ fontSize: 12 }}>Fecha de registro:</b>{" "}
                    {Moment(props.id.row.createdAt).format("DD-MM-YYYY")}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <span style={{ color: "#000", fontWeight: 500 }}>
                      Datos de la empresa:
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="document_id"
                        value={values.document_id}
                        error={values.errorDocument}
                        onChange={handleChange("document_id")}
                        fullWidth
                        // required
                        label="Nro. Ruc"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 13,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        style={{ background: "#FFFFFF" }}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      autoComplete="off"
                      name="name"
                      value={values.name}
                      onChange={handleChange("name")}
                      label="Nombre de la empresa"
                      error={values.errorName}
                      fullWidth
                      required
                      margin="dense"
                      variant="outlined"
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email"
                      value={values.email}
                      onChange={handleChange("email")}
                      label="Correo electrónico de la empresa"
                      error={values.errorEmail}
                      fullWidth
                      required
                      margin="dense"
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <MailOutline
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></MailOutline>
                        ),
                      }}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadStates
                      value={values.statesData}
                      refresh={changeStates}
                      idCountries={45}
                      error={values.errorStates}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="phone"
                      value={values.phone}
                      onChange={handleChange("phone")}
                      label="Número de Whatsapp"
                      fullWidth
                      required
                      InputProps={{
                        style: {
                          textAlign: "center",
                        },
                        endAdornment: (
                          <WhatsApp
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></WhatsApp>
                        ),
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      inputProps={{
                        maxLength: 12,
                      }}
                      margin="dense"
                      variant="outlined"
                      error={values.errorPhone}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadCities
                      value={values.citiesData}
                      refresh={changeCities}
                      disabled={disabledCities}
                      idStates={values.states}
                      error={values.errorCities}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="direccion"
                      value={values.direccion}
                      onChange={handleChange("direccion")}
                      label="Dirección de la empresa"
                      fullWidth
                      required
                      margin="dense"
                      variant="outlined"
                      error={values.errorDireccion}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                    <span style={{ color: "#000", fontWeight: 500 }}>
                      Configuración:
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "80%" }}>
                      <TextField
                        name="percentage"
                        value={values.percentage}
                        onChange={handleChange("percentage")}
                        error={values.errorPercentage}
                        fullWidth
                        required
                        size="small"
                        label="Porcentaje"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 3,
                        }}
                        type="number"
                        InputProps={{
                          endAdornment: (
                            <PercentOutlined
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></PercentOutlined>
                          ),
                        }}
                        //  helperText="Si no se sabe el porcentaje de la comisión, colocar 0."
                      />
                      <Alert severity="info" sx={{ fontSize: 12 }}>
                        El porcentaje de ganancia de la empresa.
                      </Alert>
                    </FormControl>
                  </Grid>
                  {/* Campo Token API Modificado */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ background: "#fff", borderRadius: 3 }}
                  >
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <span style={{ color: "#000", fontWeight: 500 }}>
                          Token key: {formatToken(values.token)}
                        </span>

                        {/* Botón para copiar token */}
                        {values.token && (
                          <CopyToClipboard
                            text={values.token}
                            onCopy={handleCopy}
                          >
                            <Tooltip
                              title={copied ? "¡Copiado!" : "Copiar token"}
                            >
                              <IconButton edge="end" size="small">
                                <ContentCopy />
                              </IconButton>
                            </Tooltip>
                          </CopyToClipboard>
                        )}

                        {/* Botón para generar nuevo token */}
                        <Tooltip title="Generar nuevo token">
                          <IconButton
                            onClick={generateToken}
                            edge="end"
                            size="small"
                            color="primary"
                          >
                            <Refresh />
                          </IconButton>
                        </Tooltip>
                      </Box>

                      <Alert
                        severity="info"
                        sx={{ fontSize: 14, background: "transparent" }}
                      >
                        Token para integración con APIs externas.
                      </Alert>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12}>
                {loaders ? (
                  <center>
                    <img
                      src={imgLoader}
                      alt="loader"
                      style={{
                        width: 60,
                        objectFit: "contain",
                        marginTop: 25,
                      }}
                    />
                  </center>
                ) : (
                  <div style={{ float: "right" }}>
                    <ButtonExit
                      className={classes.buttonLeft}
                      onClick={handleCloseDialog(true)}
                    >
                      Cerrar
                    </ButtonExit>
                    <ButtonStyle0 onClick={submitForm} endIcon={<Save />}>
                      Guardar
                    </ButtonStyle0>
                  </div>
                )}
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
            {/* Snackbar para confirmar copia */}
            <Snackbar
              open={copied}
              autoHideDuration={2000}
              message="Token copiado al portapapeles"
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            />
          </Fragment>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
